/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    $(document).ready(function () {
      // Refresh scrollTrigger to avoid wrong markers positionning
      ScrollTrigger.refresh();
    });
    // Triggers d'apparition au scroll
    const reveal = gsap.utils.toArray(".reveal");
    reveal.forEach((text, i) => {
      ScrollTrigger.create({
        trigger: text,
        start: "top 90%",
        endTrigger: "html",
        end: "bottom top",
        toggleClass: "active",
      });
    });

    const slide = gsap.utils.toArray(".slide-in");
    slide.forEach((text, i) => {
      ScrollTrigger.create({
        trigger: text,
        start: "top 80%",
        endTrigger: "html",
        end: "bottom top",
        toggleClass: "active",
      });
    });

    const slide2 = gsap.utils.toArray(".slide-in-alt");
    slide2.forEach((text, i) => {
      ScrollTrigger.create({
        trigger: text,
        start: "top 90%",
        endTrigger: "html",
        end: "bottom top",
        toggleClass: "active",
      });
    });

    // Effet de parallax de l'image principale
    function parallax() {
      let yPos = 0 + window.scrollY / 8;
      if (yPos < 60) {
        $("#parallax").css("transform", "translateY(" + yPos + "px)");
      }
    }
    window.addEventListener("scroll", function () {
      parallax();
    });

    // Effet d'introduction des éléments de la section landing
    gsap.to("#intro-1", { x: 0, opacity: 1, duration: 1 });
    gsap.to("#intro-2", { x: 0, opacity: 1, duration: 1, delay: 0.3 });
    gsap.to("#intro-3", { x: 0, opacity: 1, duration: 1, delay: 0.6 });
    gsap.to("#intro-4", { x: 0, opacity: 1, duration: 1, delay: 0.9 });
    gsap.to("#intro-5", { x: 0, opacity: 1, duration: 1, delay: 1.5 });
    gsap.to("#intro-6", { x: 0, opacity: 1, duration: 1, delay: 1.5 });
    gsap.to("#intro-7", { y: 0, opacity: 1, duration: 1, delay: 1.8 });
    gsap.to("#intro-8", { y: 0, opacity: 1, duration: 1, delay: 2.1 });
    gsap.to("#intro-9", { y: 0, opacity: 1, duration: 1, delay: 2.4 });

    // Animation des compteurs
    $(".counts").each(function (index, element) {
      var count = $(this),
        zero = { val: 0 },
        num = count.data("number"),
        split = (num + "").split("."),
        decimals = split.length > 1 ? split[1].length : 0;

      gsap.to(zero, {
        val: num,
        duration: 3.5,
        delay: 1.8,
        onUpdate: function () {
          count.text(zero.val.toFixed(decimals));
        },
      });
    });

    // Slider des témoignages

    let testiSlider = document.getElementById("testi-slider") || false;

    /*testiSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 10,
      speed: 5000,
      pauseOnHover: true,
      swipeToSlide: true,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
          }
        },
      ]
    });*/

    /*if($('#testi-mobile-slider')){
      $('#testi-mobile-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: true,
        arrows: false,
        dots: false,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 0,
        speed: 5000,
        pauseOnHover: true,
        draggable: true,
        cssEase: 'linear',
        centerMode: true,
      });
    }*/

    if (testiSlider) {
      console.log("true");

      // Variables
      let tickerSpeed = 1.5;

      let flickity = null;
      let isPausedDesktop = false;

      let flickityMobile = null;
      let isPausedMobile = false;

      // Fonctions du slider infini
      const update = () => {
        if (isPausedDesktop) return;
        if (flickity.slides) {
          flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
          flickity.selectedIndex = flickity.dragEndRestingSelect();
          flickity.updateSelectedSlide();
          flickity.settle(flickity.x);
        }
        requestAnimationFrame(update);
      };

      const updateMobile = () => {
        if (isPausedMobile) return;
        if (flickityMobile.slides) {
          flickityMobile.x =
            (flickityMobile.x + tickerSpeed) % flickityMobile.slideableWidth;
          flickityMobile.selectedIndex = flickityMobile.dragEndRestingSelect();
          flickityMobile.updateSelectedSlide();
          flickityMobile.settle(flickityMobile.x);
        }
        requestAnimationFrame(updateMobile);
      };

      const pauseDesktop = () => {
        isPausedDesktop = true;
      };

      const playDesktop = () => {
        if (isPausedDesktop) {
          isPausedDesktop = false;
          requestAnimationFrame(update);
        }
      };

      const pauseMobile = () => {
        isPausedMobile = true;
      };

      const playMobile = () => {
        if (isPausedMobile) {
          isPausedMobile = false;
          requestAnimationFrame(update);
        }
      };

      // Initialisation du slider
      flickity = new Flickity(document.getElementById("testi-slider"), {
        autoPlay: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25,
      });
      flickity.x = 0;

      flickityMobile = new Flickity(
        document.getElementById("testi-mobile-slider"),
        {
          autoPlay: false,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          wrapAround: true,
          selectedAttraction: 0.015,
          friction: 0.25,
        }
      );
      flickityMobile.x = 0;

      // Ajout des events listener
      $("#testi-slider").mouseenter(() => {
        pauseDesktop();
      });
      $("#testi-slider").focusin(() => {
        pauseDesktop();
      });
      $("#testi-slider").focusout(() => {
        playDesktop();
      });
      $("#testi-slider").mouseleave(() => {
        playDesktop();
      });

      if ($("#testi-mobile-slider")) {
        $("#testi-mobile-slider").mouseenter(() => {
          pauseMobile();
        });
        $("#testi-mobile-slider").focusin(() => {
          pauseMobile();
        });
        $("#testi-mobile-slider").focusout(() => {
          playMobile();
        });
        $("#testi-mobile-slider").mouseleave(() => {
          playMobile();
        });
      }

      flickity.on("dragStart", () => {
        isPausedDesktop = true;
      });

      flickityMobile.on("dragStart", () => {
        isPausedMobile = true;
      });

      // lancement du ticker
      $(document).ready(() => {
        update();
        if ($("#testi-mobile-slider")) {
          updateMobile();
        }
      });
    }

    // Effet 3D des cartes de présentation
    $(".hover-effect").each(function (index, item) {
      const height = $(item).height();
      const width = $(item).width();

      $(item).mousemove(function (event) {
        const yLayer = event.pageY - $(item).offset().top;
        const xLayer = event.pageX - $(item).offset().left;
        const yRotation = 20 * ((xLayer - width / 2) / width);
        const xRotation = -20 * ((yLayer - height / 2) / height);
        $(item).css(
          "transform",
          "perspective(500px) scale(0.95) rotateX(" +
            xRotation +
            "deg) rotateY(" +
            yRotation +
            "deg)"
        );
      });

      $(item).mouseout(function () {
        $(item).css(
          "transform",
          "perspective(500px) scale(1) rotateX(0deg) rotateY(0deg)"
        );
      });
      $(item).mousedown(function () {
        $(item).css(
          "transform",
          "perspective(500px) scale(0.95) rotateX(0deg) rotateY(0deg)"
        );
      });
      $(item).mouseup(function () {
        $(item).css(
          "transform",
          "perspective(500px) scale(0.95) rotateX(0deg) rotateY(0deg)"
        );
      });
    });

    // Menu mobile

    if ($(".toggle-mobile")) {
      $(".toggle-mobile").click(function () {
        $(".menu-mobile").addClass("active");
        $("body").addClass("prevent-scroll");

        gsap.to(".menu-mobile .anim", {
          x: 0,
          opacity: 1,
          duration: 0.5,
          delay: 0.3,
        });
        gsap.to(".menu-mobile .anim-1", {
          x: 0,
          opacity: 1,
          duration: 0.5,
          delay: 0.6,
        });
        gsap.to(".menu-mobile .anim-2", {
          x: 0,
          opacity: 1,
          duration: 0.5,
          delay: 0.9,
        });
        gsap.to(".menu-mobile .anim-3", {
          x: 0,
          opacity: 1,
          duration: 0.5,
          delay: 1.2,
        });
        gsap.to(".menu-mobile .anim-4", {
          x: 0,
          opacity: 1,
          duration: 0.5,
          delay: 1.5,
        });
        gsap.to(".menu-mobile .secondary", {
          x: 0,
          opacity: 1,
          duration: 0.5,
          delay: 1.8,
        });
        gsap.to(".menu-mobile .button", {
          x: 0,
          opacity: 1,
          duration: 0.3,
          delay: 2.1,
        });
      });
    }

    if ($(".close-mobile")) {
      $(".close-mobile").click(function () {
        $(".menu-mobile").removeClass("active");
        $("body").removeClass("prevent-scroll");

        gsap.to(".menu-mobile .anim", {
          x: -50,
          opacity: 0,
          duration: 0.1,
          delay: 0.5,
        });
        gsap.to(".menu-mobile .anim-1", {
          x: -50,
          opacity: 0,
          duration: 0.1,
          delay: 0.5,
        });
        gsap.to(".menu-mobile .anim-2", {
          x: -50,
          opacity: 0,
          duration: 0.1,
          delay: 0.5,
        });
        gsap.to(".menu-mobile .anim-3", {
          x: -50,
          opacity: 0,
          duration: 0.1,
          delay: 0.5,
        });
        gsap.to(".menu-mobile .secondary", {
          x: -50,
          opacity: 0,
          duration: 0.1,
          delay: 0.5,
        });
        gsap.to(".menu-mobile .button", {
          x: -50,
          opacity: 0,
          duration: 0.1,
          delay: 0.5,
        });
      });
    }

    // Video page sticky scroll
    let video = document.querySelector(".template-videos");
    let videoHeader = document.querySelector(".template-videos header");
    let headerFilter = document.querySelector(
      ".template-videos header .header-filters-mobile"
    );
    let isScroll = false;
    if (typeof video != "undefined" && video != null) {
      window.addEventListener("scroll", function () {
        if (window.scrollY > 250) {
          videoHeader.classList.add("sticky-filter");
          isScroll = true;
        } else if (isScroll && window.scrollY < 250) {
          videoHeader.classList.remove("sticky-filter");
          isScroll = false;
        }
      });
    }

    /// Filtrer en fonction des catégories + pagination
    const filterMobile = document.querySelector(".videos-filters-mobile");
    if (filterMobile !== "undefined" && filterMobile !== null) {
      const openFilter = document.querySelector(".filters-mobile__header");
      openFilter.addEventListener("click", function () {
        filterMobile.classList.toggle("show-filter");
      });
    }
    const headerFilterMobile = document.querySelector(".header-filters-mobile");
    if (headerFilterMobile !== "undefined" && headerFilterMobile !== null) {
      const openFilter = document.querySelector(
        ".header-filters-mobile__header"
      );
      openFilter.addEventListener("click", function (e) {
        e.preventDefault();
        headerFilterMobile.classList.toggle("show-filter");
      });
    }

    var filter = "all";
    var page = 1;

    function isActiveFilter() {
      if (filter == "all") {
        $(".filters .all-videos").addClass("active-filter");
      } else {
        $(".filters .all-videos").removeClass("active-filter");
      }
    }

    isActiveFilter();
    $(".filters .filters-cat").click(function () {
      var activeData;

      $(".filters .filters-cat").not(this).removeClass("active-filter");
      $(this).addClass("active-filter");
      activeData = $(this).data("filter");
      console.log("🧐 ~ file: common.js:448 ~ activeData->", activeData);
      let activeFilter = $(".filters-mobile .active-filter").text();
      console.log("🧐 ~ file: common.js:455 ~ activeFilter->", activeFilter);

      $(".header-filters-mobile .filters-cat").each(function () {
        if ($(this).data("filter") == activeData) {
          $(this).addClass("active-filter");
        } else {
          $(this).removeClass("active-filter");
        }
      });
      $(".videos-filters-mobile .filters-cat").each(function () {
        if ($(this).data("filter") == activeData) {
          $(this).addClass("active-filter");
        } else {
          $(this).removeClass("active-filter");
        }
      });
      $(".filters").removeClass("show-filter");
      var currentFilter = $(".filters-mobile .current-filter");
      console.log("🧐 ~ file: common.js:473 ~ currentFilter->", currentFilter);
      currentFilter.empty().html(activeFilter);
    });

    $(".filters-mobile .current-filter").hide();
    $(".filters-mobile").click(function (e) {
      console.log("🧐 ~ file: common.js:474 ~ e->", e);
      if ($(".filters-mobile").hasClass("show-filter")) {
        $(".all-videos").show();
        $(".current-filter").hide();
      } else {
        $(".all-videos").hide();
        $(".current-filter").show();
      }
    });

    function handlePage() {
      $(".template-videos .videos-pages .page").click(function () {
        var that = $(this);
        $(".template-videos .videos-pages .page").each((page) => {
          if (page !== that) {
            $(page).removeClass("active-page");
          }
        });
        if ($(this).hasClass("pagination-page")) {
          $(this).addClass("active-page");
        }
        page = $(that).data("page");
        refreshVideos();
      });
    }

    handlePage();

    $(".filters .filters-cat").click(function (event) {
      event.preventDefault();
      if (filter == $(this).data("filter")) {
        filter = "all";
      } else {
        filter = $(this).data("filter");
      }
      page = 1;
      isActiveFilter();
      refreshVideos();
    });

    function refreshVideos() {
      $(".videos-content").empty();
      $(".videos-pages").empty();
      $(".videos-content").addClass("loading");
      $.ajax({
        url: vetopartner.ajaxurl,
        method: "POST",
        dataType: "json",
        data: {
          action: "getPost",
          filter: filter,
          security: vetopartner.ajax_nonce,
          page: page,
        },
      }).done(function (data) {
        $(".videos-content").removeClass("loading");
        if (data.items != "") {
          $(".videos-content").append(data.items);
        }
        if (data.pagination != "") {
          $(".videos-pages").append(data.pagination);
        }
        handlePage();
        handleFrame();
      });
    }

    //Modal iframe
    var video_url = "";
    function handleFrame() {
      $(".thumbnail-wrapper .thumbnail-img .thumbnail-iframe").click(function (
        event
      ) {
        event.preventDefault();
        video_url = $(this).attr("href");
        refreshModal();
      });
    }
    handleFrame();
    function refreshModal() {
      $(".template-videos .modal-overlay").remove();
      $(".template-videos .modal-overlay").addClass("loading");
      $.ajax({
        url: vetopartner.ajaxurl,
        method: "POST",
        dataType: "json",
        data: {
          action: "getModal",
          video_url: video_url,
          security: vetopartner.ajax_nonce,
        },
      }).done(function (data) {
        if (data.items != "") {
          $(".template-videos").prepend(data.items);
          $(".modal-content iframe")[0].src += "?autoplay=1";
        }
        $(".template-videos .modal-overlay").click(function () {
          $(".template-videos .modal-overlay").remove();
        });
      });
    }
  },
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/common.js